module.exports = __webpack_public_path__ + "facebook.png?a6e77790227542e7c7e86d04ee43ab43";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/facebook.png
// module id = 190
// module chunks = 0